import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-home-infobox",
  templateUrl: "./home-infobox.component.html",
  styleUrls: ["./home-infobox.component.css"],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule],
})
export class HomeInfoboxComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
